import axios from 'axios'
import { Loading, Message } from 'element-ui'
import router from "../router"
import appsettings from "./appsettings";
import store from '../store/index'

const options = {
    lock: true,
    text: '正在查询……',
    spinner: 'el-icon-loading',
    background: 'rgba(0, 0, 0, 0.7)'
}
axios.defaults.baseURL = appsettings.apiroot;
let _loading;
var _errorMessage;
var reqNum = 0
axios.defaults.timeout = 200000;

let loading;
//内存中正在请求的数量
let loadingNum = 0;

function startLoading () {
    if (loadingNum == 0) {
        loading = Loading.service({
            lock: false,
            text: '正在查询……',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
        })
    }
    loadingNum++;
}

function endLoading () {
    //请求数量减1
    loadingNum--
    if (loadingNum <= 0) {
        loading.close()
    }
}

axios.defaults.withCredentials = false;
axios.interceptors.request.use(function (config) {
    config.metadata = { startTime: new Date() };
    startLoading()
    return config;
}, function (error) {
    Message({
        message: '请求失败',
        type: 'error',
        duration: 2000,
        showClose: true
    })
    endLoading()
    return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {
    endLoading()
    response.config.metadata.endTime = new Date()
    response.duration = response.config.metadata.endTime - response.config.metadata.startTime
    return response;
}, function (error) {
    endLoading()
    return Promise.reject(error);
});

const login = (method, url, params) => {
    const config = {
        baseURL: appsettings.apiroot,
        method: method.toLocaleUpperCase() || 'POST',
        url,
        data: params
    };
    return new Promise((resolve, reject) => {
        axios(config)
            .then((res) => {
                const data = JSON.parse(res.data);
                resolve(data);
            })
            .catch((err) => {
                let error = err.response;
                reject(error);
                endLoading()
            });
    });
};

const fetch = (method, url, params = {}) => {
    const config = {
        baseURL: appsettings.apiroot,
        method: method.toLocaleUpperCase() || 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        url,
    };
    Object.assign(params, { 'token': localStorage.getItem('token') ? localStorage.getItem('token') : 'CSSC' })
    
    if (method === 'GET' || method === 'DELETE') {
        config.params = params;
    } else {
        config.data = params;
    }
    if (!config.url) {
        return;
    }
    config.data = config.data || {};
    if (config.method === 'DELETE') {
        config.data = {};
    }
    return new Promise((resolve, reject) => {
        axios(config)
        .then((res) => {
                var duration = res.duration;
                res = JSON.parse(res.data);
                res.apiDuration = duration;
                if (res.status == 0) {
                    resolve(res);
                } else if (res.status == 9999) {
                    localStorage.removeItem('token')
                    localStorage.removeItem('userInfo')
                    router.push({ path: '/login', query: { goindex: true } })
                } else {
                    resolve(res)
                }
            })
            .catch((err) => {
                endLoading()
                reject(err);
            });
    });
};

const getUrlParam = function (name) {
    return decodeURIComponent((new RegExp('[?|&]'+name+'='+'([^&;]+?)(&|#|;|$)').exec(location.href)||[,""])[1].replace(/\+/g,'%20'))||null;
};


const fetchForm = (url, params) => {
    const config = {
        baseURL: appsettings.apiroot,
        method: 'POST',
        headers: {
            'Content-Type': 'multipart/form-data'
        },
        url,
    };
    console.log(params,'params4444444444444');
    params.append("token", localStorage.getItem('token') ? localStorage.getItem('token') : 'CSSC');
    console.log(params,'4444444444444444444');

    config.data = params;
    if (!config.url) {
        return;
    }
    config.data = config.data || {};
    return new Promise((resolve, reject) => {
        axios(config)
            .then((res) => {
                res = JSON.parse(res.data);
                if (res.status == 0) {
                    resolve(res);
                } else if (res.status == 9999) {
                    localStorage.removeItem('token')
                    router.push({ path: '/login', query: { goIndex: true } })
                } else {
                    resolve(res)
                }
            })
            .catch((err) => {
                endLoading()
                reject(err);
            });
    });
};

export { fetch, login, fetchForm, getUrlParam }


// WEBPACK FOOTER //
// ./src/utils/request.js